@switch (etat()) {
  @case (ofEtat.EN_ATTENTE_PLANNIF) {
    <mat-icon class="icon" svgIcon="round_progress_empty" [style.color]="etatColor()"></mat-icon>
  }
  @case (ofEtat.EN_ATTENTE_PROD) {
    <mat-icon class="icon" svgIcon="round_progress_half" [style.color]="etatColor()"></mat-icon>
  }
  @case (ofEtat.EN_PROD) {
    <mat-icon class="icon" svgIcon="round_progress_3_quarter" [style.color]="etatColor()"></mat-icon>
  }
  @case (ofEtat.EN_ATTENTE_REINTE_PDC) {
    <mat-icon class="icon" svgIcon="arrow_left_circle" [style.color]="etatColor()"></mat-icon>
  }
  @case (ofEtat.EN_ATTENTE_VALIDATION) {
    <mat-icon class="icon" [style.color]="etatColor()">check_circle</mat-icon>
  }
  @case (ofEtat.VALIDE) {
    <mat-icon class="icon" svgIcon="round_progress_full" [style.color]="etatColor()"></mat-icon>
  }
  @case (ofEtat.ANNULE) {
    <mat-icon class="icon" [style.color]="etatColor()">highlight_off</mat-icon>
  }
}

